import * as React from "react";

import type { SnapshotCollection } from "@/modules/snapshots/snapshotCollection.types";
import type {
  SnapshotCollectionsSummary as SnapshotCollectionsSummaryValue,
  SnapshotTemplateNavigatorModel,
  SnapshotCollectionTableRow,
} from "@/modules/snapshots/snapshotCollections/dashboardUtils";

import { SnapshotCollectionsOutcomes } from "../outcomes";
import { SnapshotCollectionsDashboardSidebar } from "./sidebar";
import { SnapshotCollectionsSummary } from "./summary";
import { SnapshotCollectionsTable } from "./table";

interface Props {
  activeCollectionId?: string;
  collectionQuery: string;
  navigatorModel: SnapshotTemplateNavigatorModel;
  rows: SnapshotCollectionTableRow[];
  selectedCollection?: SnapshotCollection;
  sidebarSearch: string;
  summary: SnapshotCollectionsSummaryValue;
  onCollectionQueryChange: (query: string) => void;
  onOpenCollection: (collection: SnapshotCollection) => void;
  onOpenSubcollection: (collection: SnapshotCollection, subcollectionId: string) => void;
  onSidebarSearchChange: (query: string) => void;
}

export const SnapshotCollectionsDashboard: React.FC<Props> = ({
  activeCollectionId,
  collectionQuery,
  navigatorModel,
  rows,
  selectedCollection,
  sidebarSearch,
  summary,
  onCollectionQueryChange,
  onOpenCollection,
  onOpenSubcollection,
  onSidebarSearchChange,
}) => (
  <div className="grid h-[calc(100vh-4rem)] grid-cols-[388px_minmax(0,1fr)] gap-[34px] overflow-hidden bg-[#f7f3ee] px-8 pb-7 pt-7">
    <div className="min-w-0 overflow-y-auto">
      <SnapshotCollectionsDashboardSidebar
        activeCollectionId={activeCollectionId}
        model={navigatorModel}
        search={sidebarSearch}
        onSearchChange={onSidebarSearchChange}
        onOpenCollection={onOpenCollection}
        onOpenSubcollection={onOpenSubcollection}
      />
    </div>

    <main className="min-w-0 overflow-y-auto">
      <header className="mb-5">
        <h1 className="truncate text-3xl font-bold leading-tight text-[#111b35]">SnapShot Collections</h1>
        <p className="mt-1 text-sm font-medium text-gray-500">
          All template-driven snapshot sets across the workspace.
        </p>
      </header>

      <SnapshotCollectionsSummary summary={summary} />

      <div className="mt-5 min-w-[760px]">
        <SnapshotCollectionsTable
          activeCollectionId={activeCollectionId}
          query={collectionQuery}
          rows={rows}
          onQueryChange={onCollectionQueryChange}
          onOpenCollection={onOpenCollection}
        />
      </div>

      {selectedCollection && (
        <div className="mt-6 min-w-[760px]">
          <SnapshotCollectionsOutcomes selectedCollection={selectedCollection} />
        </div>
      )}
    </main>
  </div>
);
